<jha-function-view class="dialog-background" [jhaIsBusy]="sending">
  <jha-group-box jhaTitle="Forgot Password" class="jha-form-login">
    <jha-inline-notification
      [jhaIsClosable]="true"
      jhaType="Success"
      jhaIconType="Success"
      *ngIf="sent">
      An email has been sent to your email address. Use the information provided
      in the email to access your account. You will be redirected to the 
      page shortly.
    </jha-inline-notification>

    <jha-inline-notification
      [jhaIsClosable]="true"
      jhaType="Error"
      jhaIconType="Error"
      *ngIf="serviceError">
      {{ serviceErrorMessage }}
    </jha-inline-notification>
    <form [formGroup]="forgotForm" (ngSubmit)="submit()" *ngIf="!sent">
      <div
        class="row form-group"
        [ngClass]="{
          'has-error': email.invalid && (email.dirty || email.touched)
        }">
        <div class="col-md-12">
          <label for="inputUser" class="control-label jha-required-indicator"
            >Email</label
          >
          <input
            id="email"
            class="form-control"
            placeholder="Email Address"
            formControlName="email" />
        </div>
      </div>

      <div #recaptcha class="g-recaptcha" expired-callback="expCallback"></div>

      <div class="reset-button text-center">
        <jha-button
          jhaWidth="60%"
          jhaText="Reset"
          jhaButtonStyle="Primary"
          id="reset-button"
          (jhaClick)="submit()"
          [jhaIsDisabled]="!isValid()"></jha-button>
      </div>
    </form>
  </jha-group-box>
</jha-function-view>
